import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { ApiService } from 'app/services/api.service';
import { HotjarService } from 'app/services/hotjar.service';
import { UserService } from 'app/services/user.service';

import { ActionTrackerService } from './../../../../app/services/actiontracker.service';
import { UnleashService } from './../../../../shared/unleash/unleash.service';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'contacts-analytics',
	templateUrl: './contacts-analytics.component.html',
	styleUrls: ['./contacts-analytics.component.scss'],
})
export class ContactsAnalyticsComponent implements OnInit {
	public iframeUrl = '';
	public isLoading = true;
	public showIframe = false;
	public userIsPremium = false;
	public isSupersetEnabled = false;

	public dashboard = environment.superset.dashboards.contacts.id;

	constructor(
		public apiService: ApiService,
		public unleashService: UnleashService,
		public userService: UserService,
		public atAService: ActionTrackerService,
		public hotjarService: HotjarService,
		protected router: Router
	) {}

	ngOnInit(): void {
		this.isSupersetEnabled = this.unleashService.isEnabled('superset-contacts');
		this.userService
			.checkSubscriptionAndContactTiers()
			.then(
				({ hasActiveSubscription }) =>
					(this.userIsPremium = hasActiveSubscription)
			);

		this.userService.checkSubscriptionAndContactTiers().then((user) => {
			if (user.hasActiveSubscription) {
				if (!this.isSupersetEnabled) {
					this.apiService
						.getEmbedUrlForLooker('551')
						.toPromise()
						.then((url) => {
							this.iframeUrl = url;
							this.isLoading = false;
							this.atAService.eventTracker(
								SCOPE_TYPE.Contact,
								SUBSCOPE_TYPE.List,
								ITEM_TYPE.Analytics,
								null,
								{}
							);
							this.hotjarService.setEvent('viewed_contact_analytics');
						});
				} else {
					this.isLoading = false;
				}
			}
		});
	}

	goToInsights(): void {
		this.router.navigate(['/insights']);
	}
}
